import React from 'react';
import ExternalSvg from 'components/ExternalSvg';
import { AshaIconProps } from '../types';

const AshaHotBeverages = ({ width = '24px', height = '24px' }: AshaIconProps) => (
  <ExternalSvg customer="asha" iconName="ashaHotBeverages" width={width} height={height} />
);

export default AshaHotBeverages;
